import { render, staticRenderFns } from "./TemplateCloneForm.vue?vue&type=template&id=020c8a45&scoped=true"
import script from "./TemplateCloneForm.vue?vue&type=script&lang=js"
export * from "./TemplateCloneForm.vue?vue&type=script&lang=js"
import style0 from "./TemplateCloneForm.vue?vue&type=style&index=0&id=020c8a45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020c8a45",
  null
  
)

export default component.exports